import PropTypes from 'prop-types';

export const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  return (
    <div className="flex items-center space-x-2">
      <button
        className={`px-3 py-1 border dark:border-gray-800 rounded-md ${
          currentPage === 1
            ? 'opacity-50 cursor-not-allowed'
            : 'hover:bg-gray-200 dark:hover:bg-gray-800'
        }`}
        disabled={currentPage === 1}
        onClick={() => {
          if (currentPage > 1) onPageChange(currentPage - 1);
        }}
      >
        Previous
      </button>

      <button
        className={`px-3 py-1 border dark:border-gray-800 rounded-md ${
          currentPage === totalPages
            ? 'opacity-50 cursor-not-allowed'
            : 'hover:bg-gray-200 dark:hover:bg-gray-800'
        }`}
        disabled={currentPage === totalPages}
        onClick={() => {
          if (currentPage < totalPages) onPageChange(currentPage + 1);
        }}
      >
        Next
      </button>
    </div>
  );
};

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};
